import { CRM_CRMFORMTYPEID_FIRMA } from '@/constants/crm.js';
import { PERSON_LEGALTYPE_BUSINESS, PERSON_LEGALTYPE_INDIVIDUAL } from '@/constants/person.js';
import WebsiteDefaultModel from '../src/models/Website/WebsiteDefaultModel';

export default {
  _getPersonLegalTypeFromCrm(crm) {
    if (!crm.crmformtype) {
      return null;
    }

    return (_.get(crm, 'crmformtype.id', null) === CRM_CRMFORMTYPEID_FIRMA
      || _.get(crm, 'crmformtype', null) === CRM_CRMFORMTYPEID_FIRMA)
      ? PERSON_LEGALTYPE_BUSINESS
      : PERSON_LEGALTYPE_INDIVIDUAL;
  },

  index(url, sortType = 'desc', config = {}) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms' + url,
      {
        ...config,
        headers: { Sort: sortType },
      },
    );
  },

  search(
    data = { search: '' },
    config = {},
  ) {
    return axios
      .post(
        import.meta.env.VITE_SITE_URL + '/crms/search',
        data,
        config,
      );
  },

  indexCrmIdList(statusId) {
    let id = statusId ? '/' + statusId : '';
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/ids-per-status' + id);
  },

  async indexCrmRole(id) {
    return await axios.get(import.meta.env.VITE_SITE_URL + '/crms/' + id + '/roles');
  },

  store({ crm: crmData }) {
    let crm = prepareCrm(crmData);
    const legaltype = this._getPersonLegalTypeFromCrm(crm);

    crm.client.id = 0;
    crm.client.person.id = 0;
    crm.client.person.legaltype = legaltype;

    crm.client.person.personaddress.id = 0;
    crm.client.person.personbankaccount.id = 0;
    crm.client.person.company.address = crm.client.person.company?.address?.id;
    crm.client.person.company.legaltype = legaltype;

    return axios.post(import.meta.env.VITE_SITE_URL + '/crms', {
      crm,
    });
  },
  async storeFromGus(nip) {
    return await axios.post(import.meta.env.VITE_SITE_URL + '/crms', { nip });
  },
  update(data) {
    let crm = prepareCrm(data.crm);
    const legaltype = this._getPersonLegalTypeFromCrm(crm);
    crm.client.person.legaltype = legaltype;
    crm.client.person.company.legaltype = legaltype;

    return axios.put(import.meta.env.VITE_SITE_URL + '/crms/' + crm.id, {
      crm,
      _actions: data.actions || {},
    });
  },
  updateNative(data) {
    let crm = prepareCrm(data.crm);
    const legaltype = this._getPersonLegalTypeFromCrm(crm);
    crm.client.person.legaltype = legaltype;
    crm.client.person.company.legaltype = legaltype;

    return axios.put(import.meta.env.VITE_SITE_URL + '/crms/native/' + crm.id, {
      crm,
      _actions: data.actions || {},
    });
  },
  async show(payload) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/' + payload.id);
  },
  async showByOriginal({ original }) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/by-original/' + original);
  },
  showNative(payload) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/native/' + payload.id);
  },
  getVersions(original) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/versions/' + original);
  },
  getDefaultDictionary() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/service-type/getDefaultDictionary');
  },
  getNotDefaultDictionary(pricelistId) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/service-type/getNotDefaultDictionary/' + pricelistId);
  },
  getMainBroker() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/get-main-broker');
  },
  processWebsiteData(
    data = WebsiteDefaultModel(),
  ) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/website/process`, data);
  },

  getWebsiteData() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/crms/website/get-data`);
  },
  getPublicCrmData(identity) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/api/crms/${ identity }/company-name`);
  },
  activate({
             crm_id,
             crm_original,
           }) {
    return axios.post(import.meta.env.VITE_SITE_URL + `/crms/${ crm_original }/activations`, {
      crm_id,
    });
  },
  deactivate({
               crm_id,
               crm_original,
             }) {
    return axios.delete(import.meta.env.VITE_SITE_URL + `/crms/${ crm_original }/activations`, {
      crm_id,
    });
  },
  recharge({ change, currency }) {
    return axios.post(import.meta.env.VITE_SITE_URL + `/crms/recharge`, {
      change,
      currency,
    });
  },
  STATUS: {
    index() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/statuses');
    },
    update(payload) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/crms/updateCrmStatus/' + payload.crmId,
        {
          crm: {
            id: payload.crmId,
            status: payload.statusId,
            parent: payload.parent,
          },
        },
      );
    },
  },

  ACTION: {
    index(crmId) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/crms/actions?list', { headers: { CrmId: crmId } });
    },
    store(action) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/actions', { action }, {
        headers: {
          CrmId: action.crm,
        },
      });
    },
    impersonate(crmId, asIs) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/crms/impersonate', { crmId, asIs });
    },
  },
  ADDRESS: {
    index() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses');
    },
    store(address) {
      address = { ...address };
      let person = JSON.parse(localStorage.getItem('person'));
      address.person = person.id;
      address.country = 1;
      return axios.post(import.meta.env.VITE_SITE_URL + '/persons/addresses', { address: address });
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
    },
    update(address) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + address.id, { address: address });
    },
    destroy(id) {
      return axios.delete(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
    },
  },
};

function prepareCrm(crm) {
  crm = JSON.parse(JSON.stringify(crm));
  if (crm.status && crm.status.id) {
    crm.status = crm.status.id;
  }
  return crm;
}
